import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { AUTH_HANDLER } from '../../features/auth/tokens/auth.tokens';

/**
 * La porta della postazione operatore, e la sola che resta quando il tenant ha spento l'accesso
 * del cittadino: senza quei comandi in intestazione non esisterebbe piu' un modo di arrivare al login
 * dall'interfaccia. Per questo non guarda nessun flag — spegnerla renderebbe il portale inaccessibile a
 * chi ci lavora.
 *
 * Non rende niente: come `authGuard`, manda il browser fuori dalla SPA verso il BFF, che e' l'unico a
 * parlare OAuth. L'indirizzo lo nomina l'Handler.
 */
export const operatorLoginGuard: CanActivateFn = () => {
  window.location.href = inject(AUTH_HANDLER).loginUrl();

  return false;
};
